import classNames from 'classnames';
import React from 'react';
import * as styles from './IntegrationLoginButton.module.scss';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import type { BrandAndProductProps } from '../../components/ExternalBrandLogo';
import ExternalBrandLogo from '../../components/ExternalBrandLogo';
import { UIActions } from '../../ui/uiSlice';
import request from '../../utils/network/request';
import AccountContentContainer from '../AccountContentContainer';
import getRedirectQueryString from '../getRedirectQueryString';

interface IntegrationLoginButtonProps {
  instruction: string;
  platform: string;
  platformName: string;
  provisionId?: string;
  provisionSecret?: string;
  register: boolean;
}

const IntegrationLoginButton = ({
  instruction,
  platform,
  platformName,
  provisionId,
  provisionSecret,
  register,
}: IntegrationLoginButtonProps) => {
  const dispatch = useAppDispatch();
  const login = () => {
    const redirectPath =
      new URL(window.location.href).searchParams.get('redirectPath') ||
      undefined;

    const query = {
      provision_id: provisionId,
      provision_secret: provisionSecret,
      redirect_path: `/login${getRedirectQueryString(redirectPath)}`,
    };

    request(`/api/${platform}/login`, 'GET', query)
      .then((data) => {
        document.location = (data as { url: string }).url;
      })
      .catch(() => {
        dispatch(
          UIActions.pushToast(
            {
              level: 'error',
              message: `Could not connect to ${platform}`,
            },
            5000,
          ),
        );
      });
  };

  const action = register || provisionId ? 'Register' : 'Log in';

  return (
    <div className={classNames(styles.container, styles[platform])}>
      <Button variant="secondary" block onClick={login}>
        <div className={styles.buttonIconText}>
          <ExternalBrandLogo
            {...({ brand: platform } as BrandAndProductProps)}
            height={16}
          />
          <span>
            {action} with {platformName}
          </span>
        </div>
        <AccountContentContainer.ButtonInstruction>
          {instruction}
        </AccountContentContainer.ButtonInstruction>
      </Button>
    </div>
  );
};

export default IntegrationLoginButton;
